export default __webpack_public_path__ + "images/GREENAIR.6a4215f.png";